import { jsx as _jsx } from "react/jsx-runtime";
import { StyledAutomationsComponent } from "./Automations.scss";
const automations = [
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation1.png",
        description: "When due date arrives, notify item subscribers"
    },
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation2.png",
        description: "When priority changes to high, move item to group high priority"
    },
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation3.png",
        description: "When status changes to done, create an update"
    }
];
const AutomationsComponent = ()=>/*#__PURE__*/ _jsx(StyledAutomationsComponent, {
        className: "automations-wrapper",
        children: automations.map((a)=>/*#__PURE__*/ _jsx("img", {
                className: "automation-image",
                src: a.src,
                alt: a.description
            }))
    });
export default AutomationsComponent;
